import styled from "styled-components";

import { FlexDiv } from "@/components/Atoms/Box";
import StyledSvgSprite from "@/components/Atoms/SVGSprite";

import Typography from "@/foundation/Typography/V2";
import theme from "@/foundation/Theme";

export const BreadcrumbWrapper = styled(FlexDiv)`
  background-color: #fcfcfd;
`;

export const StyledBreadcrumb = styled(FlexDiv)`
  align-items: center;
  padding: 16px;
  gap: 16px;
`;

export const Icon = styled(StyledSvgSprite)`
  height: 16px;
  width: 16px;
  stroke: ${theme.colorsV2.gray.shade_800};
`;

export const Home = styled(Typography)`
  color: ${theme.colorsV2.gray.shade_800};
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0.4px;
`;

export const Section = styled(Typography)`
  color: ${theme.colorsV2.gray.shade_400};
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0.4px;
`;
